import { Fragment } from 'react';
import { Configure, Index } from 'react-instantsearch';

import { useTranslation } from '@klv/hooks/useTranslation';
import { generateClassName } from '@klv/shared/utils/functions';

import HitWrapper from './hit-wrapper';

import useSearchData from '../search/hooks/useSearchData';

import * as styles from './styles/search.module.scss';

import type { TSearchIndexes } from '@klv/molecules/unified-search-results/types';

interface ICustomInstantResults {
  customHeadline?: string;
  filterIndex?:  TSearchIndexes;
  customFilter?: string;
}
const InstantResults = ({ customHeadline, filterIndex, customFilter = '' }: ICustomInstantResults) => {
  const data = useSearchData(); 
  const { t } = useTranslation();
  const locale = t('langCodes_locale');

  return (
    <div className={styles.instantResults}>
      {data.filter(({ showCard }) => showCard).map(({ headline, hitComponent, indexName }) => {
        const customIndex = filterIndex ? filterIndex : indexName;
        if (customIndex === indexName) {
          return (
            <Fragment key={customIndex}>
              <div className={generateClassName(['p2', 'semibold', styles.instantResultCategory])}>{customHeadline ? customHeadline : headline}</div>
              <Index indexName={customIndex}>
                <Configure hitsPerPage={5} filters={(customIndex === 'help_center_articles'  || customIndex === 'marketing_sites') ? `locale:${locale} ${customFilter}` : `${customFilter}`}/>
                <HitWrapper escapeHTML={false} hitComponent={hitComponent} />
              </Index>
            </Fragment>
          );
        }
      },
      )}
    </div>
  );
};

export default InstantResults;
